<template>
    <card>
            <template slot="header">
                <h3 class="card-title">Leave Cretdit Config</h3>
            </template>
            <nav class="row">
                <ol class="breadcrumb arr-right bg-breadcrum">
                   <li class="breadcrumb-item">
                      <router-link to="dashboard"><i class="fa fa-home"></i>&nbsp;Dashboard</router-link>
                   </li>
                     <li class="breadcrumb-item">
                        <router-link to="settings"></i>&nbsp;Change Password </router-link>
                     </li>
                     <li class="breadcrumb-item active">&nbsp;Leave Credit Config</li>
                     <li class="breadcrumb-item">
                        <router-link to="notificationconfig"></i>&nbsp;Notification Config</router-link>
                    </li>
                </ol>
             </nav>
             <hr style="margin-top:-10px"/>
             <div class="table-responsive ">
                <table class="table table-striped table-hover ">
                        <thead>
                                <tr>
                                    <th width="150">Sub Department ID</th>
                                    <th width="200">Sub Department Name</th>
                                    <th width="150">Monthly Earn</th>
                                    <th width="150">Leave Refresh</th>
                                    <!-- <th>Updated</th> -->
                                    <th width="650">Decription</th>
                                    <th width="200">Action</th>
                                </tr>
                        </thead>
                        <tbody>
                             <tr v-for="item,i in items">
                                <td>{{item.sub_id}}</td> 
                                <td>{{item.sub_department_name}}</td> 
                                <td>{{item.monthly_earn }}</td> 
                                <td>{{item.leave_refresh | capitalize}}</td> 
                                <td>{{item.description}}</td>
                                <td>
                                   <a href="#"  @click="get_selected_id(item)"v-b-modal.update-credit-config><u><i class="fa fa-pencil"></i>&nbsp;Update Config</u></a> 
                                </td>
                            </tr>
                        </tbody>
                </table>
                  <!-- MODAL FOR UPDATE RECORD  -->
                    <b-modal id="update-credit-config" ref="hide-credit-config"  size="l"   title="Update Item"  hide-footer>
                            <h3>Credit Config</h3>
                              <div class="form-group">
                                <label>Monthly Earn</label>
                                   <input type="text" class="form-control" v-model="selected_user.monthly_earn">
                             </div>
                              <div class="form-group">
                                <label>Leave Refresh</label>
                                <select class="form-control" v-model="selected_user.leave_refresh">
                                    <option value="monthly">Monthly</option>
                                    <option value="yearly">Yearly</option>
                               </select>
                              </div>
                             <div class="form-group">
                                <label>Descrption</label>
                                  <textarea  rows="4" class="form-control" v-model="selected_user.description"></textarea>
                             </div>
                            
                             <button  @click="update_credit_config" class="btn btn-info float-right"><i class="fa fa-save"></i>&nbsp;Save Changes</button>
                             <br/> <br/> 
                    </b-modal>
            </div>
    </card>		
</template>
<script>
/* eslint-disable */
import Card from 'src/components/UIComponents/Cards/Card.vue'

export default {
    components: {
        Card
    },
    data(){
        return{
           items:[],
           selected_user:''
        }
        },
    created:function () {
      this.getLeaveCredit()
    },    
    methods:{
      
        update_credit_config(){
           axios.post('api/credits/config/update/' + this.selected_user.id, {
                   monthly_earn: this.selected_user.monthly_earn,
                   leave_refresh: this.selected_user.leave_refresh,
                   description: this.selected_user.description,
                })
                .then(response => {
                    this.$swal({
                        type: 'success',
                        title: 'Save',
                        text: 'You successfully save',
                        showConfirmButton: false,
                        timer: 2000
                    })
                this.getLeaveCredit()
                this.$refs['hide-credit-config'].hide();
                console.log(response)
                })
                .catch(error => {
                console.log(error)
                });
        },

        get_selected_id(item){
              this.selected_user = item
        },

 
        getLeaveCredit(){
               axios
                 .get('api/leave/credits/config')
                 .then(resp => { this.items = resp.data})
                 .catch(error => {  console.log(error.response)  });
        },
        formSubmit(e){
            e.preventDefault()
        }
    },

}
</script>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/bp-settings/todo-credit-config.vue